<template>
    <div
    class="blocks"
    :class="{['columns-' + props.columns]: true}"
    >
        <slot/>
    </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';

const props = defineProps({
    columns: {
        type: Number,
        default: 3,
        required: false
    }
})
</script>

<style lang="scss" scoped>
.blocks {
    display: flex;
    flex-wrap: wrap;

    align-items: flex-start;
    justify-content: start;

    > * {
        flex-direction: column;
        margin-bottom: 0.5em;
    }

    &.columns-1 > * {
        flex: 0 0 100%;
    }

    &.columns-2 > * {
        flex: 0 0 48%;

        &:not(:nth-child(2n)) {
            margin-right: 3.5%;
        }
    }

    &.columns-3 > * {
        flex: 0 0 31%;

        &:not(:nth-child(3n)) {
            margin-right: 3.5%;
        }
    }

    &.columns-4 > * {
        flex: 0 0 31%;

        &:not(:nth-child(4n)) {
            margin-right: 3.5%;
        }
    }
}
</style>
